import React from 'react';
import cx from 'classnames';
import { Button } from 'components/base';
import { NavigationMenuLinks, Link, LinkListVariantType, BodyLinks } from 'types';

interface Props {
  className?: string;
  data: NavigationMenuLinks | BodyLinks | null;
  variant: LinkListVariantType;
  toggleMainMenu?: () => void;
}

const LinkList: React.FC<Props> = ({ data, className, variant, toggleMainMenu }) => {
  if (!data) {
    return null;
  }

  const hasNavStyling = variant === LinkListVariantType.NAV;
  const hasBodyStyling = variant === LinkListVariantType.BODY;
  const hasArticleSidebarStyling = variant === LinkListVariantType.ARTICLE_SIDEBAR;

  return (
    <div
      className={cx('LinkList apercu flex', className, {
        'text-navigation-link': hasNavStyling || hasArticleSidebarStyling,
        'flex-col': hasNavStyling || hasBodyStyling,
        'LinkList--style-article xl-lg:p0 flex-row lg:flex-col': hasArticleSidebarStyling,
        'py1_75 md:py2_5': hasBodyStyling,
      })}
    >
      <div
        className={cx({
          'LinkList__link-title': hasBodyStyling,
          'LinkList--style-article__link-title flex col-6 lg:col-12': hasArticleSidebarStyling,
          'color-green': hasArticleSidebarStyling,
        })}
      >
        {data.title}
      </div>
      {data && data.links && (
        <div
          className={cx({
            'col-6 lg:col-12': hasArticleSidebarStyling,
            LinkList__link: hasBodyStyling,
          })}
        >
          {data.links.map((link: Link) => (
            <div
              className={cx('LinkList__links-container', {
                'flex flex-row lg:flex-col col-12': hasArticleSidebarStyling,
              })}
              key={link.url}
            >
              <Button
                className={cx('LinkList__link apercu bg-color-transparent color-bronze transition-shorter', {
                  'text-navigation-link': hasNavStyling,
                })}
                ariaLabel={link.linkLabel || ''}
                to={link.url}
                onClick={hasNavStyling ? toggleMainMenu : undefined}
              >
                <span>{link.linkLabel}</span>
              </Button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LinkList;
